// Currency Handler - Optimized
// Initialize when DOM is ready
(function(){
  function start() {
    const currency = window.shopifyCurrency;
    const symbol = window.shopifyCurrencySymbol;
    if (currency !== 'EUR' || !symbol) return;

    function patch(node) {
      let nodes = [];
      if (node.querySelectorAll) {
        nodes = node.querySelectorAll('.rebuy-cart__flyout-item-price span.rebuy-money span:not(.sr-only)');
      }
      nodes.forEach(function(n){
        if (n.dataset && n.dataset.currencyPatched === '1') return;
        if (n.textContent && n.textContent.indexOf('$') !== -1) {
          n.textContent = n.textContent.replace('$', symbol);
          if (n.dataset) n.dataset.currencyPatched = '1';
        }
      });
    }

    function initObserver() {
      if (!document.body || window.__currencyObserverInitialized) return;
      window.__currencyObserverInitialized = true;
      // Initial pass
      patch(document);

      const mo = new MutationObserver(function(mutations){
        for (let i = 0; i < mutations.length; i++) {
          const m = mutations[i];
          if (m.type === 'childList') {
            m.addedNodes && m.addedNodes.forEach && m.addedNodes.forEach(function(node){
              if (!node || node.nodeType !== 1) return;
              if (node.querySelector && (node.classList && (node.classList.contains('rebuy-cart__flyout') || node.classList.contains('rebuy-cart__flyout-item-price')) || node.querySelector('.rebuy-cart__flyout-item-price'))) {
                patch(node);
              }
            });
          } else if (m.type === 'characterData') {
            const p = m.target && m.target.parentElement;
            if (p) patch(p);
          }
        }
      });
      mo.observe(document.body, { subtree: true, childList: true, characterData: true });
    }

    // Defer heavy work to idle or after load
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initObserver, { timeout: 3000 });
    } else {
      window.addEventListener('load', function(){ setTimeout(initObserver, 1500); }, { once: true });
    }

    // Also initialize on first cart interaction to avoid delays
    const triggers = [
      document.querySelector('[data-cart-toggle]'),
      document.querySelector('.Header-cartLink'),
      document.querySelector('.MobileTabBar-cart')
    ];
    triggers.forEach(function(el){
      if (!el) return;
      const once = function(){
        initObserver();
        el.removeEventListener('click', once);
        el.removeEventListener('mouseenter', once);
        el.removeEventListener('touchstart', once);
      };
      el.addEventListener('click', once, { passive: true });
      el.addEventListener('mouseenter', once, { passive: true });
      el.addEventListener('touchstart', once, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
